module.exports = __webpack_public_path__ + "static/media/sinon.1041f049.png";